export default [
  {
    address: "0xba100000625a3754423978a60c9317c58a424e3D",
    symbol: "BAL",
  },
  {
    address: "0x616e8BfA43F920657B3497DBf40D6b1A02D4608d",
    symbol: "auraBAL",
  },
  {
    address: "0x5c6Ee304399DBdB9C8Ef030aB642B10820DB8F56",
    symbol: "B-80BAL-20WETH",
  },
] as const
